import {
  gotoPageInCategory,
  selectActiveProjectId,
  selectCategoryPagination,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { PageDestination } from '@core/core/types'
import { useCallback } from 'react'

export const useCategoryPaging = () => {
  const pagingInfo = useAppSelector(selectCategoryPagination)
  const projectId = useAppSelector(selectActiveProjectId)
  const dispatch = useAppDispatch()

  const pager = useCallback(
    (page: PageDestination) => {
      dispatch(gotoPageInCategory({ projectId, page }))
    },
    [dispatch, projectId],
  )

  return { pagingInfo, pager }
}
